import React from 'react'
import PropTypes from 'prop-types'
import { evaluateBinding } from 'utils/dependencies'
import { doesBindingContainRandomFormula } from 'utils/bindings'
import { Input as InputNewBase } from './InputNew'
import {
  Input as InputOldBase,
  connectInput as connectInputOld,
} from './InputOld'

// Use the "new" connector; both connectors are compatible but this aligns with new behavior
export const connectInput = connectInputOld

class Input extends InputOldBase {
  static contextTypes = {
    ...InputOldBase.contextTypes,
    getFlags: PropTypes.func,
  }

  shouldUseNew = () => {
    const { getFlags } = this.context
    const flags = getFlags?.() || {}
    return flags.hasOnSubmitInputAction === true
  }

  componentDidMount() {
    if (!this.shouldUseNew() && super.componentDidMount) {
      super.componentDidMount()
    }
  }

  componentDidUpdate(prevProps) {
    if (!this.shouldUseNew() && super.componentDidUpdate) {
      super.componentDidUpdate(prevProps)
    }
  }

  componentWillUnmount() {
    if (!this.shouldUseNew() && super.componentWillUnmount) {
      super.componentWillUnmount()
    }
  }

  render() {
    const useNew = this.shouldUseNew()

    if (useNew) {
      return <InputNewBase {...this.props} />
    }

    return super.render()
  }
}

const inputMapState = (state, props) => {
  const { defaultValue } = props.object.attributes
  const isRandomDefaultValue = doesBindingContainRandomFormula(defaultValue)

  return {
    defaultValue: evaluateBinding(state, defaultValue, props),
    isRandomDefaultValue,
  }
}

export default connectInput(Input, null, inputMapState)
